import { Group, Stack, Tabs, Text, ThemeIcon, Title } from '@mantine/core';
import { IconCurrencyDollar } from '@tabler/icons-react';
import React from 'react';
import VenuePricing from './VenuePricing';

const PricingTabs: React.FC = () => {
    return (
        <Stack gap="sm" h={{ md: 'calc(100dvh - 8.5rem)' }} style={{ minHeight: 0 }}>
            <Group gap="sm">
                <ThemeIcon size="lg" radius="md" variant="gradient" gradient={{ from: 'indigo', to: 'cyan' }}>
                    <IconCurrencyDollar size={22} stroke={1.5} />
                </ThemeIcon>
                <div>
                    <Title order={2}>Pricing</Title>
                    <Text c="dimmed" size="sm">
                        Internal pricing explorer
                    </Text>
                </div>
            </Group>
            <Tabs defaultValue="venue" style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                <Tabs.List>
                    <Tabs.Tab value="venue">Venue</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="venue" pt="md" style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                    <VenuePricing showHeader={false} />
                </Tabs.Panel>
            </Tabs>
        </Stack>
    );
};

export default PricingTabs;
